import type { JSX } from 'react';
import { Box } from '@mui/material';
import EmptyState from './common/EmptyState';

export default function FeatureDisabledState(): JSX.Element {
  return (
    <Box className="flex items-center justify-center flex-1 vtwo:p-24">
      <EmptyState
        title="Feature not enabled"
        subtitle="This feature is not enabled for your pharmacy. If this is a mistake, please contact your account manager to enable it."
      />
    </Box>
  );
}
